/* eslint-disable no-unused-vars */
import { ModalBase } from 'components';

import { Repository } from './repository/Repository';

export const ChooseCreativeImage = ({
  isOpen$,
  isLoading,
  isFetching,
  imgList,
  previewSectionImage$,
  currentSelectedSize$,
  uploadAction,
  uploadResult,
  detectWidthAndHeight,
}) => {
  return (
    <ModalBase>
      <Repository
        isOpen$={isOpen$}
        imgList={imgList}
        isLoading={isLoading}
        isFetching={isFetching}
        previewSectionImage$={previewSectionImage$}
        detectWidthAndHeight={detectWidthAndHeight}
        currentSelectedSize$={currentSelectedSize$}
        uploadAction={uploadAction}
        uploadResult={uploadResult}
      />
    </ModalBase>
  );
};
